import { useContext } from 'react';
import PropTypes from 'prop-types';

import Description from './Description';
import SummaryNavLink from '../SummaryNavLink';
import SummaryNavLinkButton from '../SummaryNavLinkButton';

import { APPLICANT } from '../../../../../../constants/overviewSections';
import { IcraaComplianceContext } from '../../../../../../contexts/IcraaComplianceContext';
import { useApplicationSummaryContext } from '../../../../../../contexts/ApplicationSummaryContext';
import { Text } from '@zillow/constellation';
import { emitApplicantLinkEvent } from '../../../../../../../client/analytics/clickstreamEvents';
import { useListingUser } from '../../../../../../hooks/useListingUser';

const TITLE = 'Applicant summary';
const LABEL = 'View';

export default function RentalApplicationNavLink({ applicant }) {
  const { user, listing } = useListingUser();
  const { hasComplianceError, onNavLinkClick } = useContext(IcraaComplianceContext);
  const { isApplicationDeclined } = useApplicationSummaryContext();

  return (
    <SummaryNavLink
      {...{
        title: TITLE,
        description: isApplicationDeclined ? (
          <Text id="ra-nav-link__unavailable-text">Details unavailable</Text>
        ) : (
          <Description userId={applicant.userId} zgAuthZone={applicant.zgAuthZone} />
        ),
        button:
          hasComplianceError || isApplicationDeclined ? null : (
            <SummaryNavLinkButton
              id="ra-nav-link__summary-link-btn"
              {...{
                applicant,
                sectionId: APPLICANT,
                title: TITLE,
                label: LABEL,
              }}
              onClick={() => {
                onNavLinkClick({
                  sectionId: APPLICANT,
                  onAllCompliantCallback: () => emitApplicantLinkEvent(listing, user),
                });
              }}
            />
          ),
      }}
    />
  );
}

RentalApplicationNavLink.displayName = 'RentalApplicationNavLink';

RentalApplicationNavLink.propTypes = {
  applicant: PropTypes.object.isRequired,
};
